import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

const apiClient = axios.create({
  baseURL: apiUrl,
  withCredentials: true,
});

// A separate client (no interceptors) for refresh calls
const refreshClient = axios.create({
  baseURL: apiUrl,
  withCredentials: true,
});

let isRefreshing = false;
let refreshPromise = null;

const clearClientSession = () => {
  try {
    // mirror `log_out.function.js` (avoid importing to prevent circular deps)
    localStorage.removeItem('logInState');
    sessionStorage.removeItem('logInState');
    sessionStorage.removeItem('logInUserEmail');
    localStorage.removeItem('permissions');
    sessionStorage.removeItem('totalFttsAlarms');
    sessionStorage.removeItem('tenantId');
    sessionStorage.removeItem('tenantName');
    sessionStorage.removeItem('totalMpbnAlarms');
    sessionStorage.removeItem('totalOtnAlarms');
    sessionStorage.removeItem('totalIpranAlarms');
    sessionStorage.removeItem('selectedTab');
  } catch (e) {
    // ignore
  }
};

const shouldSkipAuthRefresh = (config) => {
  const url = config?.url || '';
  return (
    url.includes('/auth/login') || url.includes('/auth/refresh') || url.includes('/auth/logout')
  );
};

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error?.config;

    if (!originalRequest) {
      return Promise.reject(error);
    }

    const status = error?.response?.status;

    if (status !== 401 || originalRequest._retry || shouldSkipAuthRefresh(originalRequest)) {
      return Promise.reject(error);
    }

    originalRequest._retry = true;

    if (!isRefreshing) {
      isRefreshing = true;
      refreshPromise = refreshClient
        .post('/auth/refresh')
        .then(() => true)
        .catch(() => false)
        .finally(() => {
          isRefreshing = false;
        });
    }

    const didRefresh = await refreshPromise;

    if (!didRefresh) {
      clearClientSession();
      window.location.href = '/';
      return Promise.reject(error);
    }

    return apiClient(originalRequest);
  }
);

export default apiClient;
